import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import { API_BASE_PATH } from '@/config';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { TPaginatedQuery } from '@/types';

import { AdditionalCompensation } from '../types';

export const getReviewedAdditionalCompensations = (
  page?: string,
  sort?: string,
  createdBetween?: string,
  status = 'accepted,rejected,canceled,processed,paid',
  type?: string,
  query?: string
): Promise<TPaginatedQuery<AdditionalCompensation[]>> =>
  axios.get(`${API_BASE_PATH}/workers/additional-compensations`, {
    params: {
      'filter[status]': status,
      'filter[type]': type,
      'filter[createdBetween]': createdBetween,
      'filter[q]': query,
      sort,
      page,
    },
  });

type QueryFnType = typeof getReviewedAdditionalCompensations;

type UseAdditionalCompensationsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useReviewedAdditionalCompensations = ({
  config,
}: UseAdditionalCompensationsOptions = {}) => {
  const [searchParams] = useSearchParams();

  const page = searchParams.get('page') || undefined;
  const sort = searchParams.get('sort') || undefined;
  const createdBetween = searchParams.get('filter[createdBetween]') || undefined;
  const status = searchParams.get('filter[status]') || undefined;
  const type = searchParams.get('filter[type]') || undefined;
  const query = searchParams.get('filter[q]') || undefined;

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      'reviewed-additional-compensations',
      page,
      sort,
      createdBetween,
      status,
      type,
      query,
    ],
    queryFn: () =>
      getReviewedAdditionalCompensations(page, sort, createdBetween, status, type, query),
  });
};
